import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=f71be7b8&scoped=true"
import script from "@/views/ResetPassword/ResetPassword.ts?vue&type=script&lang=ts&external"
export * from "@/views/ResetPassword/ResetPassword.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/ResetPassword/reset-password.scss?vue&type=style&index=0&id=f71be7b8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71be7b8",
  null
  
)

export default component.exports